module.exports = __webpack_public_path__ + "img/cp-4.732be37a.jpg";